module.exports = __webpack_public_path__ + "img/手表-1.17291112.png";